import { getBooleanFromValue, isFunction, isObject, isSet } from '@/global/utils/utils'

const TAB_KEY = 'canBus'
export default {
  data () {
    return {
      digitalOutputsAutocompleteItems: []
    }
  },

  computed: {
    canBusConfig () {
      return {
        title: this.$t('base/tracker.can_bus'),
        key: TAB_KEY,
        visible: getBooleanFromValue(this.permissions?.canReadCanBus),
        apiConfig: {
          get: {
            module: 'base',
            route: `tracker/${this.resolveRouteParamValue('id')}/can-bus`
          },
          post: {
            module: 'base',
            route: `tracker/${this.resolveRouteParamValue('id')}/can-bus`
          }
        },
        dataFetched: (event) => this.onCanBusDataFetched(event, event?.data?.data),
        afterSave: (event, data) => this.onCanBusDataFetched(event, data),
        afterCancel: (event) => this.onCanBusDataFetched(event, event?.formDataForSend),
        tabContent: [
          {
            component: this.tabActionButtonsComponent,
            title: this.$t('base/tracker.can_bus'),
            showBackButton: {
              onGoBack: () => this.navigatesToTableView(this.trackersOverviewViewName)
            }
          },
          {
            component: this.columnsContentComponent,
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'can_bus_status',
                    label: this.$t('base/tracker.can_bus_status'),
                    type: 'autocomplete',
                    items: [
                      {
                        id: 1,
                        name: this.$t('base.active')
                      },
                      {
                        id: 0,
                        name: this.$t('base.inactive')
                      }
                    ],
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'max_num_of_revolutions',
                    label: this.$t('base/tracker.max_num_of_revolutions'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'red_zone_revolutions_start_at',
                    label: this.$t('base/tracker.red_zone_revolutions_start_at'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'max_speed',
                    label: this.$t('base/tracker.max_speed'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'speed_unit_id',
                    label: this.$t('base/tracker.speed_unit'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'base',
                      route: 'speed-units'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    onCanBusDataFetched (event, data) {
      const { updateData, updateFormData } = event || {}
      const updateDataCallback = isFunction(updateData)
        ? updateData
        : (isFunction(updateFormData)
            ? updateFormData
            : null
          )
      if (isSet(data) && isObject(data) && isFunction(updateDataCallback)) {
        updateDataCallback({
          can_bus_status: data?.is_active,
          speed_unit_id: data?.speed_unit?.id || data?.speed_unit
        })
      }
    }
  }
}
